import axios from "axios";
import { store } from "../redux/store";

// const url = process.env.REACT_APP_API_URL || "http://localhost/facturize/facturize_saft/php/server";
const url = process.env.REACT_APP_API_URL || "https://saft.facturize.net/server";


const api = axios.create({
  baseURL: `${url}/index.php/api`,
});

// Interceptador para adicionar o token dinamicamente
api.interceptors.request.use((config) => {
  const state = store.getState(); 
  const token = state.user?.token;
 
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

const socket = {
  on: () => socket,
  off: () => socket,
  emit: () => socket,
  disconnect: () => {},
};

export { 
  api, 
  url, 
  socket 
};
